import {useEffect, useState} from "react";

// Api
import {GetLatestVideos} from "../../../../Api/Video";

// Models
import CountWrapper from "../../../../Models/DTOs/CountWrapper";
import VideoDTO from "../../../../Models/DTOs/VideoDTO";
import ICarouselContentDTO from "../../../../Models/DTOs/ICarouselContentDTO";

// Helpers
import {transformVideoToCarouselContent} from "../../../../Helpers/DataConversion/ConvertToCarouselContentItem";

function useFetchJustReleased() {
    const
        [justReleased, setJustReleased] = useState<ICarouselContentDTO[] | null>(null),
        [justReleasedLoading, setJustReleasedLoading] = useState<boolean>(false),
        [justReleasedError, setJustReleasedError] = useState<string>("");

    useEffect(() => {
        const controller = new AbortController();

        setJustReleasedLoading(true);
        setJustReleasedError("");

        (async () => {
            try {
                const data: CountWrapper<VideoDTO> = await GetLatestVideos({
                    take: 12,
                    publishedOnly: true,
                    signal: controller.signal,
                });

                // Deduplicate videos by Id
                const uniqueVideos = data.items.filter(
                    (item, index, self) =>
                        index === self.findIndex((t) => t.Id === item.Id)
                );

                // Transform to carousel content
                const content = uniqueVideos.map(transformVideoToCarouselContent);

                setJustReleased(content);
            } catch (err: any) {
                if (err?.name === "CanceledError" || err?.name === "AbortError") return;

                setJustReleasedError("Failed to fetch just released.");
                console.error(err);
            } finally {
                setJustReleasedLoading(false);
            }
        })();

        return () => controller.abort();
    }, []);

    return {justReleased, justReleasedLoading, justReleasedError};
}

export default useFetchJustReleased;
